<section class="prize-box main-compet-box">
	<div class="container">
        <div class="overlap-title">
            <h1 class="primary-title prize-bg-tile">prizes</h1>
            <h4 class="secondary-title prizes-secondary-title">Compete & Win  ₹ 10 Lakh in prizes</h4>
        </div>
        
        <div class="prize-inr-section">
            <div class="text-center">
                <h4>PRIZES IN INR</h4>
            </div>
            <!-- mobile none -->
            <div class="main-box mobile-none">
                <h1 class="totle-price"><span> ₹ 3,00,000  </span></h1>
                <div class="prize-postion">First Place</div>
                <div class="d-flex align-items-center justify-content-center first-row">
                    <div class="prize-txt no-border lv-2">
                        ₹ 1,50,000 
                        <span>
                            Second Place
                        </span>
                    </div>
                    <div class="prize-txt lv-2">
                         ₹ 1,00,000 
                        <span>
                            Third Place
                        </span>
                    </div>
                </div>
                <div class="d-flex mt-40 align-items-center justify-content-center second-row">
                    <div class="prize-txt no-border">
                         ₹ 80,000  
                        <span>
                            Fourth Place
                        </span>
                    </div>
                    <div class="prize-txt">
                         ₹ 70,000  
                        <span>
                            Fifth Place
                        </span>
                    </div>
                    <div class="prize-txt">
                         ₹ 60,000  
                        <span>
                            Sixth Place
                        </span>
                    </div>
                    <div class="prize-txt">
                         ₹ 50,000  
                        <span>
                            Seventh Place
                        </span>
                    </div>
                    <div class="prize-txt last-prize-text">
                         ₹ 40,000  
                        <span>
                            Eighth Place
                        </span>
                    </div>
                </div>
                <div class="d-flex mt-40 align-items-center justify-content-center third-row">
                    <div class="prize-txt no-border">
                         ₹ 25,000 
                        <span>
                            9th - 10th Place 
                        </span>
                    </div>
                    <div class="prize-txt">
                         ₹ 20,000  
                        <span>
                            11th - 12th Place 
                        </span>
                    </div>
                    <div class="prize-txt">
                         ₹15,000  
                        <span>
                            13th - 16th Place 
                        </span>
                    </div>
                </div>
                <!-- <div class="d-flex mt-40 align-items-center justify-content-center fourth-row bottom-prize-box">
                    <div class="prize-txt no-border">
                         ₹ 50,000 
                        <span>
                            Most Valuable Player
                        </span>
                    </div>
                    <div class="prize-txt">
                         ₹ 50,000 
                        <span>
                            Most Finishes by a team
                        </span>
                    </div>
                    <div class="prize-txt">
                         ₹ 3,00,000
                        <span>
                            Winner of Each Match ( Finals - 10,000 * 30)
                        </span>
                    </div>
                </div> -->
                
            </div>
            <!-- pc none -->
            <div class="main-box pc-none">
                <h1 class="totle-price"><span> ₹ 3,00,000  </span></h1>
                <div class="prize-postion">First Place</div>
                <div class="d-flex align-items-center justify-content-center first-row">
                    <div class="prize-txt no-border lv-2">
                        ₹ 1,50,000 
                        <span>
                            Second Place
                        </span>
                    </div>
                    <div class="prize-txt lv-2">
                         ₹ 1,00,000  
                        <span>
                            Third Place
                        </span>
                    </div>
                </div>
                <div class="d-flex mt-40 align-items-center justify-content-center second-row">
                    <div class="prize-txt no-border">
                         ₹ 80,000  
                        <span>
                            Fourth Place
                        </span>
                    </div>
                    <div class="prize-txt">
                         ₹ 70,000  
                        <span>
                            Fifth Place
                        </span>
                    </div>
                    <div class="prize-txt">
                         ₹ 60,000  
                        <span>
                            Sixth Place
                        </span>
                    </div>
                    <div class="prize-txt">
                         ₹ 50,000  
                        <span>
                            Seventh Place
                        </span>
                    </div>
                    <div class="prize-txt">
                         ₹ 40,000  
                        <span>
                            Eighth Place
                        </span>
                    </div>
                <!-- </div>
                <div class="d-flex mt-40 align-items-center justify-content-center third-row"> -->
                    <div class="prize-txt">
                         ₹ 25,500  
                        <span>
                            9th - 10th Place 
                        </span>
                    </div>
                    <div class="prize-txt">
                         ₹ 20,000  
                        <span>
                            11th - 12th Place 
                        </span>
                    </div>
                    <div class="prize-txt">
                         ₹15,000  
                        <span>
                            13th - 16th Place 
                        </span>
                    </div>
                </div>
                <!-- <div class="d-flex mt-40 align-items-center justify-content-center fourth-row bottom-prize-box">
                    <div class="prize-txt no-border">
                         ₹ 50,000 
                        <span>
                            Most Valuable Player
                        </span>
                    </div>
                    <div class="prize-txt">
                         ₹ 50,000 
                        <span>
                            Most Finishes by a team
                        </span>
                    </div>
                    <div class="prize-txt last-prize-text">
                         ₹ 3,00,000
                        <span>
                            Winner of Each Match ( Finals - 10,000 * 30)
                        </span>
                    </div>
                </div> -->
            </div>
        </div>
	</div>
</section>

<style>

	.prize-box {
		background: #ffffff;
		min-height: 573px;
	}

	.data-text {
		text-shadow: 0 2px 3px rgba(0, 0, 0, 0.24);
		z-index: -1;
		font-size: 180px;
		font-weight: 500;
		font-stretch: normal;
		font-style: normal;
		line-height: normal;
		letter-spacing: normal;
		text-align: center;
		color: #425570;
	}
    
    .torunament-text {
        color:#fff;
        line-height: 21px;
        font-size:14px;
        font-weight: 400;
    }

    .torunament-text img {
        width: 43px;
        height: 45px;
    }

    .find-a-team-link span {
        top:-4px;
    }
    @media only screen and (max-width: 767px) and (min-width: 300px){
        .lv-2{
            font-size: 1.5em;
        }
    }
</style>